import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="offer" className="py-24 px-6 bg-gradient-to-b from-navy-900 to-navy-600 relative overflow-hidden" data-id="element-135">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-neon/10 rounded-full blur-[120px] pointer-events-none" data-id="element-136" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-block bg-red-500/10 border border-red-500/30 px-4 py-1.5 rounded-full mb-8" data-id="element-138">
          <span className="text-red-400 font-bold tracking-[0.2em] text-sm uppercase" data-id="element-139">
            ⚠️ OFERTA POR TIEMPO LIMITADO
          </span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-10" data-id="element-140">
          Accede a la guía completa hoy
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 50,
        delay: 0.2
      }} className="flex flex-col md:flex-row items-center justify-center gap-6 mb-8" data-id="element-141">
          <span className="text-3xl text-slate-400 line-through decoration-red-500/50 font-medium" data-id="element-142">
            ANTES $49
          </span>
          <span className="text-6xl md:text-7xl font-black text-cyan-neon drop-shadow-[0_0_20px_rgba(0,242,255,0.4)]" data-id="element-143">
            $6.39 USD
          </span>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-xl text-slate-300 mb-12 max-w-2xl mx-auto" data-id="element-144">
          Incluye los 6 capítulos, 60 páginas prácticas y actualizaciones
          futuras.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="flex flex-col items-center" data-id="element-145">
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={() => {
          trackAddToCart();
          window.open('https://www.betterdailyguides.com/cart/51856246309166:1', '_blank');
        }} className="w-full max-w-[460px] bg-gradient-to-r from-green-cta to-green-cta-light text-black font-black text-xl md:text-2xl py-6 px-8 rounded-2xl cta-pulse shadow-[0_0_40px_rgba(0,200,83,0.5)] mb-6 transition-all" data-id="element-146">
            Consigue tu Guía Ahora
          </motion.button>

          <p className="text-slate-400 text-sm font-medium" data-id="element-147">
            Descarga inmediata. Resultados desde hoy.
          </p>
        </motion.div>
      </div>
    </section>;
}